<template>
  <v-container>
    <v-btn block flat @click.native.stop="more">{{ $t('messenger.more') }}</v-btn>
    <div v-for="user in messagesPerUser" :key="user.key" class="message-group">
      <router-link class="subheading mb-2"
        :to="{ name: user.scope === 'user' ? 'User' : 'Expert', params: { id: user.externalId, tab: 'profile' } }">
        {{ user.name }}
      </router-link>
      <date-formatter class="caption" :value="user.firstSentDate"></date-formatter>

      <message
        v-for="message in user.messages" :key="message._id"
        :value="message">
      </message>
    </div>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import { Date as DateFormatter } from '@/components/formatters'
  import pagination from '@/mixins/pagination'
  import scrollableToBottom from '@/mixins/scrollableToBottom'
  import withConversation from '@/mixins/withConversation'
  import Message from './Message'
  const MINUTES = 60 * 1000

  export default {
    components: {
      DateFormatter,
      Message
    },
    mixins: [
      pagination('skiliko/messages'),
      withConversation,
      scrollableToBottom
    ],
    data () {
      return {
        scrollTimeout: null,
        filter: {
          conversationId: this.conversation._id,
          page: 1
        }
      }
    },
    computed: {
      allMessages () {
        const page = this.filter.page
        let messages = []
        for (let i = 1; i <= page; i++) {
          const id = this.generatePageKey({
            ...this.filter,
            page: i
          })
          const currentPage = this.pages[id] || {}
          messages = [
            ...(currentPage.list || [])
              .map(id => this.collection[id]),
            ...messages
          ]
        }
        return messages
      },
      sortedMessages () {
        return this.allMessages
          .sort((a, b) => {
            const aDate = a.sentAt || new Date()
            const bDate = b.sentAt || new Date()
            return aDate.localeCompare(bDate)
          })
          .filter((value, index, self) => self.findIndex(x => x._id === value._id) === index)
      },
      messagesPerUser () {
        const users = []
        let currentUser = null
        for (let i = 0; i < this.sortedMessages.length; i++) {
          const message = this.sortedMessages[i]
          if (!currentUser ||
              currentUser.name !== message.from.name ||
              +new Date(currentUser.lastSendDate) + 5 * MINUTES < +new Date(message.sentAt)) {
            currentUser = {
              ...message.from,
              key: i,
              firstSentDate: message.sentAt,
              lastSendDate: message.sentAt,
              messages: []
            }
            users.push(currentUser)
          }
          currentUser.messages.push(message)
          currentUser.lastSendDate = message.sentAt
        }
        return users
      }
    },
    watch: {
      conversation () {
        this.filter = {
          ...this.filter,
          conversationId: this.conversation._id
        }
      },
      messages () {
        this.markAsRead({ ids: this.messages.map(e => e._id) })
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout)
        }
        this.scrollTimeout = setTimeout(() => (this.skipScroll = false), 1000)
      }
    },
    methods: {
      ...mapActions({
        markAsRead: 'skiliko/messages/markAsRead'
      }),
      more () {
        this.skipScroll = true
        this.filter = {
          ...this.filter,
          page: this.filter.page + 1
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .message-group > a {
    text-decoration: none;
    display: inline-block;
  }

  .message-group {
    position: relative;

    time {
      position: absolute;
      top: 0;
      right: 0;
      color: #ccc;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/messenger/Messages.vue